<template>
  <div class="ds-page-home" :class="['style-' + headerStyle, {ceiling: isCeiling}]" :style="{ 'min-width': minWidth }">
    <div v-if="showLicenseLayer" class="ds-page-home-header_license">
      <i class="iconfont icon-icon-mine-bbh ds-font3"></i>
      <span>许可证{{licenseExpireWarnKey}}天后将过期，请联系供应商进行许可更新！</span>
      <DsfButton size="small" type="plain" @click="closeLicenseLayer(true)">不再提醒</DsfButton>
      <DsfButton size="small" type="plain" @click="closeLicenseLayer(false)">知道了</DsfButton>
    </div>
    <div v-if="hasHeader" class="ds-page-home-header" :style="{ height: position.top }">
      <div key="header" class="ds-page-home-header-content" :style="{ height: position.top }">
        <slot name="header"></slot>
      </div>
    </div>
    <div class="ds-page-home-body">
      <div key="left" v-if="hasLeft" class="ds-page-home-left" :style="{ width: position.left }">
        <slot name="left"></slot>
      </div>
      <div class="ds-page-home-main">
        <div key="breadcrumb" v-if="hasBreadcrumb" class="ds-page-home-breadcrumb" :style="{ height: position.breadcrumb }">
          <slot name="breadcrumb"></slot>
        </div>
        <div key="default" v-if="viewLoaded" class="ds-page-home-view">
          <slot></slot>
        </div>
      </div>
      <div key="right" v-if="hasRight" class="ds-page-home-right" :style="{ width: position.right }">
        <slot name="right"></slot>
      </div>
    </div>
    <div key="footer" v-if="hasFooter" :style="{ height: position.bottom }" class="ds-page-home-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import menuUtils from "./utils";

const locationPath = location.href.replace(location.hash, "");

export default {
  name: "DsfHome",
  provide() {
    return {
      homeRoot: this
    };
  },
  props: {
    menuList: {
      type: Array,
      default() {
        return [];
      }
    },
    minWidth: {
      type: String,
      default: "auto"
    },
    // 角标样式。
    // text 显示文字; dot 显示点; 其他 隐藏图片；
    badgeStyle: {
      type: String,
      default: ""
    }
  },
  data() {
    this.LicenseHandleLoading = false;  //
    return {
      hasHeader: false,
      hasLeft: false,
      hasRight: false,
      hasFooter: false,
      hasBreadcrumb: false,
      position: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        breadcrumb: null
      },
      menuAction: [],
      menuIndex: [],
      menuKey: [],
      // 视图载入状态
      viewLoaded: true,
      homeControls: {},
      homeControlKeys: {
        header: 1,
        left: 1,
        breadcrumb: 1,
        default: 1,
        right: 1,
        footer: 1,
      },
      // 是否对菜单包裹一层虚拟节点
      // 对于默认导航栏有用
      isEncircleMenu: false,
      cornerMarkInfo: {
        markTypes: [],
        markId: [],
        menu_ids: []
      },
      showLicenseLayer: false,
      licenseExpireWarnKey: 0
    };
  },
  computed: {
    ...Vuex.mapState("cornerMark", ["badges", "menuIds"]),
    $menuList() {
      if (this.isEncircleMenu || dsf.config.setting_public_nav_menu_to_left == '1') {
        return [
          {
            menu_id: "root",
            menu_name: "",
            menu_icon: "",
            children: this.menuList
          }
        ];
      } else {
        return this.menuList;
      }
    },
    headerStyle() {
      return dsf.themeConfig.setting.defaultHeaderMini;
    },
    // 是否吸顶
    isCeiling() {
      return this.homeControls["DsfDefaultHomeHeaderMenuChildren"] && dsf.themeConfig.setting.defaultHeaderCeiling;
    }
  },
  watch: {
    $route() {
      this.initMenu();
    },
    "menuList.length"(to, from) {
      if (!from && to) {
        this.getCornerMarkInfo(); //获取角标
        this.initMenu();
      }
    },
    $menuList(to, from) {
      if (!from.length && (!window.__multiPageVm__ || this.menuKey.join("") === "")) {
        this.initMenu();
      }
    }
  },
  created() {
    this.licenseExpireWarnKey = dsf.getCookie("license_expire_warn_key");
    if(!dsf.isUnDef(this.licenseExpireWarnKey) && this.licenseExpireWarnKey!='undefined'){
      this.showLicenseLayer = true;
    }

    dsf.updateHomeControl = {};
    _.each(this.homeControlKeys, (v, k) => {
      dsf.updateHomeControl[k] = () => {
        this.updateHomeControl(k);
      }
    });
    this.hasHeader = !!this.$slots.header;
    this.hasLeft = !!this.$slots.left;
    this.hasRight = !!this.$slots.right;
    this.hasFooter = !!this.$slots.footer;
    this.hasBreadcrumb = !!this.$slots.breadcrumb;
    if (!window.__multiPageVm__ && location.hash == "#" + this.$route.fullPath) {
      this.initMenu();
    }
    this.getCornerMarkInfo();
  },
  updated() {
    this.hasHeader = !!this.$slots.header;
    this.hasLeft = !!this.$slots.left;
    this.hasRight = !!this.$slots.right;
    this.hasFooter = !!this.$slots.footer;
    this.hasBreadcrumb = !!this.$slots.breadcrumb;
    if (!this.hasHeader) this.setPosition("top", null);
    if (!this.hasLeft) this.setPosition("left", null);
    if (!this.hasRight) this.setPosition("right", null);
    if (!this.hasFooter) this.setPosition("bottom", null);
    if (!this.hasBreadcrumb) this.setPosition("breadcrumb", null);
  },
  methods: {
    setHomeControl(name, vm) {
      this.$set(this.homeControls, name, vm);
    },
    removeHomeControl(name) {
      this.$delete(this.homeControls, name);
    },
    updateHomeControl(name) {
      if (this.homeControlKeys[name]) {
        this.$set(this.homeControlKeys, name, this.homeControlKeys[name] + 1);
      }
    },
    getCornerMarkInfo() {
      let cornerMarkInfo = this.cornerMarkInfo;
      cornerMarkInfo.markTypes = []; //建立链接的类型
      cornerMarkInfo.menu_ids = []; //菜单主键id
      this.getMenu(this.menuList);
      let markTypes = cornerMarkInfo.markTypes;
      let menu_ids = cornerMarkInfo.menu_ids;
      if (markTypes.length) {
        this.$http
          .get("cornerMark/getMarkIdList", { markTypes: markTypes.join(",") })
          .done((res) => {
            if (res.success) {
              this.$store.dispatch("cornerMark/init", {
                markId: res.data,
                menu_ids: menu_ids,
                type: "DsfHome"
              });
            }
          })
          .error((res) => {
            dsf.layer.message(res?.message || "根据菜单类型获取所有角标业务ID异常", false);
          });
      }
    },
    getMenu(lists) {
      _.forEach(lists, (list) => {
        // 类型
        let mark_type = list.mark_type;
        let markTypes = this.cornerMarkInfo.markTypes;
        let id = list.menu_id;
        if (mark_type && !this.menuIds.includes(id)) {
          this.cornerMarkInfo.menu_ids.push(id);
          if (!markTypes.includes(mark_type)) {
            markTypes.push(mark_type);
          }
        }
        if (list.children && list.children.length) {
          this.getMenu(list.children);
        }
      });
    },
    setPosition(key, value) {
      this.$set(this.position, key, value);
    },
    initMenu(url) {
      if ((this.isEncircleMenu && !this.$menuList[0].children.length) || !this.$menuList.length) {
        return;
      }
      if (!url) {
        url = location.href;
      } else if (/^#/.test(url)) {
        if (!/^#\//.test(url)) {
          url = url.replace(/^#/, "#/");
        }
        url = locationPath + url;
      }
      let currentUrl = dsf.url.parse(url);
      let menuAction = [];
      let menuIndex = [];
      let menuKey = [];
      this.filterMenu(menuAction, menuIndex, menuKey, this.$menuList, currentUrl, 0);
      for (let i = 0, l = menuIndex.length; i < l; i++) {
        if (menuIndex[i] == -1) {
          menuAction.length = menuIndex.length = menuIndex.length = i;
          break;
        }
      }
      if (menuKey.join("") !== this.menuKey.join("")) {
        this.menuAction = menuAction;
        this.menuIndex = menuIndex;
        this.menuKey = menuKey;
      } else if (this.isEncircleMenu && !menuKey.length && currentUrl.hash !== '#/') {
        this.menuAction = menuAction = [
          this.$menuList[0],
          {
            menu_id: dsf.uuid(),
            menu_name: "",
            menu_url: "./page.html" + currentUrl.hash
          }
        ];
        this.menuIndex = menuIndex = [0];
        this.menuKey = menuKey = ["root"];
      }
      // 如果检测到当前为空路由，即currentUrl.hash等于'#/'
      // 则跳转到第一个菜单去
      if (menuKey.join("") === "" && currentUrl.hash === "#/" && this.$menuList.length) {
        menuUtils.openPage.call(this, menuUtils.findMenu(this.$menuList), true);
      }
    },
    /**
     * 判断当前选中的菜单
     * @param menuAction
     * @param menuIndex
     * @param menuKey
     * @param menuList  菜单列表
     * @param currentUrl     currentUrl
     * @param n         递归层级
     */
    filterMenu(menuAction, menuIndex, menuKey, menuList, currentUrl, n) {
      menuAction[n] = {};
      menuIndex[n] = -1;
      menuKey[n] = "";
      for (let i = 0; i < menuList.length; i++) {
        const item = menuList[i];
        if ((item.param || item.menu_url) && menuUtils.urlsIsSame(item, currentUrl)) {
          menuAction[n] = item;
          menuIndex[n] = i;
          menuKey[n] = item.menu_id;
          if (!item.children || !item.children.length) {
            break;
          }
        }
        if (item.children && item.children.length) {
          this.filterMenu(menuAction, menuIndex, menuKey, item.children, currentUrl, n + 1);
          if (menuIndex[n + 1] !== -1) {
            menuAction[n] = item;
            menuIndex[n] = i;
            menuKey[n] = item.menu_id;
            break;
          }
        }
      }
    },
    /**
     * 关闭许可证过期倒计时提示框
     * @param isAlways {Boolean} 不再提醒
     */
    closeLicenseLayer(isAlways){
      if(this.LicenseHandleLoading){
        return;
      }
      this.LicenseHandleLoading = true;
      let closeFn = ()=>{
        this.showLicenseLayer = false;
        dsf.cookies.remove("license_expire_warn_key");
      }
      if(isAlways){
        this.$http.post('license/client/stopWarn',{})
          .done(({success})=>{
            if(success){
              closeFn();
            }else{
              dsf.layer.message("执行异常",flase);
            }
          })
          .error(()=>{
            dsf.layer.message("执行异常",flase);
          })
          .always(()=>{
            this.LicenseHandleLoading = false;
          })
      }else{
        closeFn();
      }
    }
  }
};
</script>